
import { useRef } from "react";
import { Header } from "../components/Header";
import { BottomNav } from "../components/BottomNav";
import { PastChallengesList } from "../components/PastChallengesList";
import { Loader2, Trophy } from "lucide-react";
import { usePastChallenges } from "../hooks/usePastChallenges";
import { useInactivityNudge } from "../hooks/useInactivityNudge";

const Results = () => {
  const {
    pastChallenges,
    isLoading,
    votedSubmissions,
    handleVote,
    isGuest,
    lastVoteRef
  } = usePastChallenges();

  const { inactivityNudge, clearNudge } = useInactivityNudge(lastVoteRef);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col bg-bauhaus-offwhite">
        <Header />
        <div className="flex-1 flex items-center justify-center">
          <Loader2 className="h-8 w-8 text-bauhaus-green animate-spin" />
        </div>
        <div className="h-16"></div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-bauhaus-offwhite">
      <Header />
      <main className="flex-1 container mx-auto px-4 pt-6 pb-24 max-w-md">
        {isGuest && (
          <div className="text-xs bg-bauhaus-green/10 text-bauhaus-green rounded px-3 py-2 mb-4">
            You’re in guest mode! <br />
            <span>
              Vote and browse results. <br /> <b>Sign up to submit photos or leave comments.</b>
            </span>
          </div>
        )}

        {inactivityNudge && (
          <div
            className="z-30 animate-fade-in p-3 mb-3 bg-bauhaus-green/20 text-bauhaus-green border border-bauhaus-green rounded text-center font-semibold select-none"
            onAnimationEnd={clearNudge}
          >
            Help pick a winner — just 3 votes left!
          </div>
        )}

        <div className="mb-6">
          <h1 className="text-2xl font-bold text-bauhaus-green mb-2">
            Past Challenges
          </h1>
          <p className="text-bauhaus-green/80">View winners from previous challenges</p>
        </div>

        {pastChallenges.length > 0 ? (
          <PastChallengesList
            pastChallenges={pastChallenges}
            votedSubmissions={votedSubmissions}
            onVote={handleVote}
          />
        ) : (
          <div className="bg-bauhaus-offwhite border-2 border-bauhaus-green rounded-lg p-6 text-center">
            <Trophy className="h-12 w-12 mx-auto text-bauhaus-green/80 mb-4" />
            <h3 className="text-lg font-medium mb-2 text-bauhaus-green">
              No past challenges yet
            </h3>
            <p className="text-bauhaus-green/80">
              Check back after today's challenge ends to see results here!
            </p>
          </div>
        )}
      </main>
      <BottomNav />
    </div>
  );
};

export default Results;
